import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const GET_AKTION_LESE_BERECHTIGUNG = '[VeranstaltungenModul] GetAktionLeseBerechtigung laden';
export const GET_AKTION_LESE_BERECHTIGUNG_AUSFUEHREN = '[VeranstaltungenModul] GetAktionLeseBerechtigung ausführen';
export const GET_AKTION_LESE_BERECHTIGUNG_ERFOLGREICH = '[VeranstaltungenModul] GetAktionLeseBerechtigung laden erfolgreich';
export const GET_AKTION_LESE_BERECHTIGUNG_FEHLER = '[VeranstaltungenModul] GetAktionLeseBerechtigung Ladefehler';
export const GET_AKTION_LESE_BERECHTIGUNG_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] GetAktionLeseBerechtigung nicht ausgeführt (evtl. Offline)';


export class GetAktionLeseBerechtigungAction implements Action {
    readonly type = GET_AKTION_LESE_BERECHTIGUNG;
        constructor( public veranstaltung_id:string ,  public aktionId:string , public optPayload: any = null) {}
    }
export class GetAktionLeseBerechtigungAusfuehrenAction implements Action {
    readonly type = GET_AKTION_LESE_BERECHTIGUNG_AUSFUEHREN;
        constructor( public veranstaltung_id:string ,  public aktionId:string , public optPayload: any = null) {}
    }
export class GetAktionLeseBerechtigungErfolgreichAction implements Action {
    readonly type = GET_AKTION_LESE_BERECHTIGUNG_ERFOLGREICH;
        constructor(public payload: api.AktionLeseBerechtigungen,  public veranstaltung_id:string ,  public aktionId:string , public optPayload: any = null) {}
    }
export class GetAktionLeseBerechtigungFehlerAction implements Action {
    readonly type = GET_AKTION_LESE_BERECHTIGUNG_FEHLER;
        constructor(public payload: any,  public veranstaltung_id:string ,  public aktionId:string , public optPayload: any = null) {}
    }
export class GetAktionLeseBerechtigungNichtAusgefuehrtAction implements Action {
    readonly type = GET_AKTION_LESE_BERECHTIGUNG_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenQueryAktionLeseBerechtigungActions =
    GetAktionLeseBerechtigungAction
    | GetAktionLeseBerechtigungAusfuehrenAction
    | GetAktionLeseBerechtigungErfolgreichAction
    | GetAktionLeseBerechtigungFehlerAction
    | GetAktionLeseBerechtigungNichtAusgefuehrtAction
    ;
